import DownloadIcon from "@atlaskit/icon/core/download";
import UploadIcon from "@atlaskit/icon/core/upload";
import ChevronRightIcon from "@atlaskit/icon/core/chevron-right";
import {token} from "@atlaskit/tokens";
import {AnankeText} from "@vesta/ananke/components/anankeText";

type ExportOptionsDrawerContentProps = {
    onExportAsPng?: () => void;
    /** Omit to hide CSV row (e.g. performance dashboard). */
    onExportAsCsv?: () => void;
    onExportAsPdf?: () => void;
    onBulkUpload?: () => void;
};

/**
 * Mobile BottomDrawer content for export options.
 */
export function ExportOptionsDrawerContent({onExportAsPng, onExportAsCsv, onExportAsPdf, onBulkUpload}: ExportOptionsDrawerContentProps) {
    const optionRowStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        gap: token("space.150", "12px"),
        height: "40px",
        minHeight: "32px",
        padding: `0 ${token("space.150", "12px")}`,
        borderRadius: "4px",
        background: token("color.background.input"),
        color: token("color.text"),
        cursor: "pointer",
    };

    const OptionRowButton = ({label, onClick, icon: Icon = DownloadIcon}: {label: string; onClick: () => void; icon?: React.ElementType}) => (
        <button
            type="button"
            onClick={onClick}
            style={optionRowStyle}
            aria-label={label}
        >
            <div style={{display: "flex", alignItems: "center", gap: token("space.150", "12px")}}>
                <Icon
                    label=""
                    color={token("color.icon")}
                />
                <AnankeText color="color.text.subtle">{label}</AnankeText>
            </div>
            <ChevronRightIcon
                label=""
                color={token("color.icon.subtle")}
            />
        </button>
    );

    return (
        <div
            className="grid gap-ds-space-100"
            style={{fontFamily: "Inter"}}
        >
            {onBulkUpload !== undefined && (
                <OptionRowButton
                    label="Bulk Upload"
                    onClick={onBulkUpload}
                    icon={(props) => (
                        <UploadIcon
                            {...props}
                            label=""
                        />
                    )}
                />
            )}
            {onExportAsPng !== undefined ? (
                <OptionRowButton
                    label="Export as PNG"
                    onClick={onExportAsPng}
                />
            ) : null}
            {onExportAsCsv !== undefined ? (
                <OptionRowButton
                    label="Export as CSV"
                    onClick={onExportAsCsv}
                />
            ) : null}
            {onExportAsPdf !== undefined ? (
                <OptionRowButton
                    label="Export as PDF"
                    onClick={onExportAsPdf}
                />
            ) : null}
        </div>
    );
}
